import facilityicon from "../../assets/shapes_svg/companydetail/facilityicon.svg";
import energyicon from "../../assets/shapes_svg/companydetail/energyicon.svg";
import vehicleicon from "../../assets/shapes_svg/companydetail/vehicleicon.svg";
import stationaryicon from "../../assets/shapes_svg/companydetail/stationaryicon.svg";
import emissionicon from "../../assets/shapes_svg/companydetail/emissionicon.svg";
import inventoryicon from "../../assets/shapes_svg/companydetail/inventoryicon.svg";
import travelicon from "../../assets/shapes_svg/companydetail/travelicon.svg";
import remoteicon from "../../assets/shapes_svg/companydetail/remoteicon.svg";
import wasteicon from "../../assets/shapes_svg/companydetail/wasteicon.svg";
import deliveryicon from "../../assets/shapes_svg/companydetail/deliveryicon.svg";
import commuteIcon from "../../assets/design-revamp-company/company-detail-headers/commute-icon.svg";
import droplet from "../../assets/shapes_svg/companydetail/droplet.svg";
import processIcon from "../../assets/shapes_svg/companydetail/process-company-icon.svg";
import useOfSoldIcon from "../../assets/shapes_svg/companydetail/company-use-sold-icon.svg";
import finalTreatmentIcon from "../../assets/shapes_svg/companydetail/final-treatment-company-icon.svg";
import yfsLabelIcon from "../../assets/new-product-detail-cats/yfs-label/yfs-prod-bg.svg";
import "./index.css";
import { useState } from "react";
import BurgerIcon from "../../components/EditIconTable/BurgerIcon";
import DiscardChangeIcon from "../../components/EditIconTable/DiscardChangeIcon";
import { t } from "i18next";

const SidebarItem = ({ icon, text, idElement }) => {
  const [hover, setHover] = useState(false);

  const scroll = () => {
    const section = document.querySelector(idElement);
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className="sidebar__item">
      <img
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        src={icon}
        alt=""
        onClick={scroll}
      />
      <h6 style={{ display: hover ? "block" : "none" }}>{text}</h6>
    </div>
  );
};

const Sidebar = () => {
  const [show, setShow] = useState(false);
  const [classRotate, setClassRotate] = useState(false);
  return (
    <>
      <div className="sidebar__navigation">
        <div
          className="sidebar__item"
          style={{ marginBottom: "20px", marginTop: "20px" }}
        >
          {show ? (
            <div
              className={classRotate ? "class_rotasi" : ""}
              onClick={(e) => {
                e.stopPropagation();
                setClassRotate(true);
                setTimeout(function () {
                  setShow(!show);
                  setClassRotate(false);
                }, 200);
              }}
              style={{
                width: "100%",
                marginLeft: "50px",
                zIndex: 3,
                cursor: "pointer",
              }}
            >
              <DiscardChangeIcon style={3} />
            </div>
          ) : (
            <div
              className={classRotate ? "class_rotasi" : ""}
              onClick={() => {
                setClassRotate(true);
                setTimeout(function () {
                  setShow(!show);
                  setClassRotate(false);
                }, 200);
              }}
              style={{ width: "100%", cursor: "pointer" }}
            >
              <BurgerIcon style={3} click={() => {}} />
            </div>
          )}
        </div>
        {show ? (
          <div className="sidebar__menus">
            <SidebarItem
              icon={facilityicon}
              text={t("FACILITY")}
              idElement={"#facility-id"}
            />
            <SidebarItem
              icon={energyicon}
              text={t("ENERGY")}
              idElement={"#energy-id"}
            />
            <SidebarItem
              icon={droplet}
              text={t("WATER")}
              idElement={"#water-id"}
            />
            <SidebarItem
              icon={vehicleicon}
              text={t("VEHICLES")}
              idElement={"#vehicle-id"}
            />
            <SidebarItem
              icon={stationaryicon}
              text={t("STATIONARY_COMBUSTION")}
              idElement={"#stationary-id"}
            />
            <SidebarItem
              icon={emissionicon}
              text={t("EMISSION_GAS")}
              idElement={"#gas-id"}
            />
            <SidebarItem
              icon={deliveryicon}
              text={t("INGOING_OUTGOING_TRANSPORT")}
              idElement={"#in-out-transport-id"}
            />
            <SidebarItem
              icon={inventoryicon}
              text={t("INVENTORY")}
              idElement={"#inventory-id"}
            />
            <SidebarItem
              icon={travelicon}
              text={t("BUSINESS_TRAVEL")}
              idElement={"#travel-id"}
            />
            <SidebarItem
              icon={commuteIcon}
              text={t("COMMUTE")}
              idElement={"#commute-id"}
            />
            <SidebarItem
              icon={remoteicon}
              text={t("REMOTE_WORKING")}
              idElement={"#remote-id"}
            />
            <SidebarItem
              icon={wasteicon}
              text={t("WASTE")}
              idElement={"#waste-id"}
            />
            <SidebarItem
              icon={processIcon}
              text={t("PROCESSING_SOLD_INTERMEDIATE")}
              idElement={"#processing-id"}
            />
            <SidebarItem
              icon={useOfSoldIcon}
              text={t("USE_OF_SOLD_PRODUCTS")}
              idElement={"#comp-usc-id"}
            />
            <SidebarItem
              icon={finalTreatmentIcon}
              text={t("FINAL_TREATMENT_PRODUCTS")}
              idElement={"#final-treatment-id"}
            />
            <SidebarItem
              icon={yfsLabelIcon}
              text={t("YFS Label")}
              idElement={"#yfs-label-id"}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Sidebar;
